import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaEnvelope,
  FaPhone
} from "react-icons/fa";
import { 
  FaCcPaypal, 
  FaCcVisa, 
  FaCcMastercard, 
  FaCcAmex 
} from "react-icons/fa6";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer style={{ backgroundColor: "#f8f9fa", paddingTop: "3rem", paddingBottom: "2rem" }}>
      {/* Full-width line */}
      <div style={{ 
        width: "100%", 
        height: "2px", 
        backgroundColor: "#6B46C1", 
        marginBottom: "3rem" 
      }}></div>

      <Container>
        <Row className="justify-content-center">
          
          {/* Contact Us Section */}
          <Col md={4} className="mb-4">
            <div className="text-center">
              <h5 style={{ 
                color: "#6B46C1", 
                fontWeight: "bold", 
                marginBottom: "1.5rem",
                fontSize: "1.2rem"
              }}>
                צור קשר
              </h5>
              
              {/* Contact Information */}
              <div className="mb-3" style={{ textAlign: "right" }}>
                <div className="mb-2 d-flex align-items-center justify-content-center">
                  <span style={{ marginLeft: "0.5rem", fontSize: "0.9rem" }}>
                    hoshvimplus@gmail.com
                  </span>
                  <FaEnvelope style={{ color: "#6B46C1", fontSize: "1rem" }} />
                </div>
                
                {/* Phone Number */}
                <div className="mb-2 d-flex align-items-center justify-content-center">
                  <span style={{ marginLeft: "0.5rem", fontSize: "0.9rem" }}>
                    052-9463663
                  </span>
                  <FaPhone style={{ color: "#6B46C1", fontSize: "1rem" }} />
                </div>
              </div>

              {/* Social Media Icons */}
              <div>
                <p style={{ 
                  fontSize: "0.9rem", 
                  fontWeight: "500", 
                  color: "#333", 
                  marginBottom: "1rem" 
                }}>
                  עקבו אחרינו
                </p>
                <div style={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center", 
                  gap: "1.5rem" 
                }}>
                  <a 
                    href="https://facebook.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ transition: "transform 0.2s" }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.1)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  >
                    <FaFacebook style={{ fontSize: "2rem", color: "#4267B2" }} />
                  </a>
                  <a 
                    href="https://instagram.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ transition: "transform 0.2s" }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.1)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  >
                    <FaInstagram style={{ fontSize: "2rem", color: "#E1306C" }} />
                  </a>
                </div>
              </div>
            </div>
          </Col>

          {/* Payment Methods Section */}
          <Col md={4} className="mb-4">
            <div className="text-center">
              <h5 style={{ 
                color: "#6B46C1", 
                fontWeight: "bold", 
                marginBottom: "1.5rem",
                fontSize: "1.2rem"
              }}>
                אמצעי תשלום
              </h5>
              
              <p style={{ 
                fontSize: "0.9rem", 
                color: "#666", 
                marginBottom: "1rem" 
              }}>
                תשלום מאובטח ובטוח
              </p>
              
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                gap: "1rem",
                flexWrap: "wrap"
              }}>
                <FaCcPaypal style={{ 
                  fontSize: "2.5rem", 
                  color: "#00457C",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }} />
                <FaCcVisa style={{ 
                  fontSize: "2.5rem", 
                  color: "#1A1F71",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }} />
                <FaCcMastercard style={{ 
                  fontSize: "2.5rem", 
                  color: "#EB001B",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }} />
                <FaCcAmex style={{ 
                  fontSize: "2.5rem", 
                  color: "#006FCF",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }} />
              </div>
            </div>
          </Col>

          {/* Legal Section */}
          <Col md={4} className="mb-4">
            <div className="text-center">
              <h5 style={{ 
                color: "#6B46C1", 
                fontWeight: "bold", 
                marginBottom: "1.5rem",
                fontSize: "1.2rem"
              }}>
                מידע נוסף
              </h5>
              
              <div style={{ marginBottom: "1.5rem" }}>
                <Link 
                  to="/regulations" 
                  style={{ 
                    color: "#6B46C1", 
                    fontWeight: "500",
                    textDecoration: "none",
                    fontSize: "1rem",
                    transition: "color 0.2s"
                  }}
                  onMouseEnter={(e) => e.target.style.color = "#553C9A"}
                  onMouseLeave={(e) => e.target.style.color = "#6B46C1"}
                >
                  תקנון האתר
                </Link>
              </div>
              
              <div style={{ marginBottom: "1rem" }}>
                <p style={{ 
                  fontSize: "1rem", 
                  color: "#333",
                  fontWeight: "500",
                  marginBottom: "0.5rem"
                }}>
                  {currentYear} &copy; חושבים פלוס
                </p>
                <p style={{ 
                  fontSize: "0.85rem", 
                  color: "#666",
                  marginBottom: "0"
                }}>
                  Designed by Roi Kruv
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
